import ReactGA from 'react-ga4'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID
const appInsightsConnectionString =
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING

let appInsights: ApplicationInsights | null = null

// Each tracker only starts if its env variable is set at build time, so
// local builds without the keys collect nothing and stay silent.
export const initAnalytics = () => {
  if (gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId)
  }

  if (appInsightsConnectionString) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: appInsightsConnectionString,
        // Page views are sent explicitly from PageViewTracker so both
        // trackers report the exact same navigation.
        enableAutoRouteTracking: false,
      },
    })
    appInsights.loadAppInsights()
  }
}

// One SPA route change = one page view in both trackers.
export const trackPageView = (path: string) => {
  if (gaMeasurementId) {
    ReactGA.send({ hitType: 'pageview', page: path })
  }
  appInsights?.trackPageView({ uri: path })
}

// Custom actions, e.g. trackEvent('surprise_me_clicked', { mediaType: 'movie' }).
export const trackEvent = (
  name: string,
  properties?: Record<string, string | number | boolean>,
) => {
  if (gaMeasurementId) {
    ReactGA.event(name, properties)
  }
  appInsights?.trackEvent({ name }, properties)
}
